import React, { useState } from 'react';
import PackageCard from './PackageCard';
import PackageModal from './PackageModal';
import { internetPackages } from './packages';

const PackagesSection = () => {
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [activeTab, setActiveTab] = useState('semua');

  const filteredPackages = activeTab === 'semua' ? internetPackages : internetPackages.filter(pkg => pkg.category === activeTab);

  const tabs = [
    { id: 'semua', label: 'Semua Paket', icon: '🌐' },
    { id: 'rumah', label: 'Rumah', icon: '🏠' },
    { id: 'bisnis', label: 'Bisnis', icon: '🏢' },
    { id: 'perusahaan', label: 'Enterprise', icon: '🏭' }
  ];
  
  return (
    <section id="packages" className="py-16 bg-gray-800">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold mb-4">Pilih Paket Internet Anda</h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto mb-8">
            Solusi internet lengkap untuk rumah, bisnis, dan perusahaan
          </p>

          {/* Filter Tabs */}
          <div className="flex flex-wrap justify-center gap-4 mb-8">
            {tabs.map(tab => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`tab-button px-6 py-3 rounded-full font-semibold transition-all ${
                  activeTab === tab.id
                    ? 'active text-white'
                    : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
                }`}
              >
                <span className="mr-2">{tab.icon}</span>
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        {/* Package Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredPackages.map((pkg) => (
            <PackageCard
              key={pkg.id}
              package={pkg}
              onViewDetails={() => setSelectedPackage(pkg)}
            />
          ))}
        </div>

        {/* Package Detail Modal */}
        {selectedPackage && (
          <PackageModal
            package={selectedPackage}
            onClose={() => setSelectedPackage(null)}
          />
        )}
      </div>
    </section>
  );
};

export default PackagesSection;